<script setup lang="ts">
import type { MatrixCell, MatrixColumn } from '../../../util/answerRecapMatrix';
import useLocale from '../../../../composables/use-locale';

const props = defineProps<{
  cell: MatrixCell;
  column: MatrixColumn;
}>();

const { t } = useLocale();

const stateColor = () =>
  props.cell.state === 'correct' ? 'green' : props.cell.state === 'wrong' ? 'highlighterred' : 'surface-container-high';
</script>

<template>
  <div class="d-flex ga-3 py-2">
    <v-avatar size="26" :color="stateColor()" class="text-caption font-weight-medium flex-shrink-0">
      {{ column.questionIndex + 1 }}
    </v-avatar>

    <div>
      <p class="text-body-2 ma-0">{{ column.phrase }}</p>
      <p class="text-caption on-surface-medium ma-0">
        <template v-if="cell.state === 'none'">
          {{ t('results.answer_recap.no_answer') }}
        </template>
        <template v-else>
          {{ t('results.answer_recap.chose') }}
          <span :class="cell.state === 'correct' ? 'text-green' : 'text-highlighterred'">
            {{ cell.letter }}. {{ cell.chosenOptionText }}
          </span>
        </template>

        <template v-if="cell.state !== 'correct'">
          ·
          <span class="text-green">
            {{
              t('results.answer_recap.correct_answer_is', { letter: column.correctLetter, text: column.correctText })
            }}
          </span>
        </template>
      </p>
    </div>
  </div>
</template>
